<div class="message-container d-flex">
    <aside class="message-list">
        <div class="header p-3xl d-flex justify-content-between">
            <div class="title d-flex gap-8 align-items-center">
                <h2>Wiadomości</h2>
                <pui-badge variant="info">{{messagesSignal()?.length}}</pui-badge>
            </div>
            <button pui-button (click)="onCreateMessage()"><pui-icon left icon="edit-05" />Nowa</button>
        </div>

        <div class="search p-3xl">
            <pui-form-field>
                <pui-icon icon="search-md" left />
                <input puiInput [placeholder]="'Wyszukaj'" />
            </pui-form-field>
        </div>


        <ul class="list">
            @for (message of filteredMessages(); track message.sentTime) {
            <li class="message-item p-3xl d-flex flex-column gap-4" [class.not-read]="!message.read"
                [class.active]="selectedMessage()?.sentTime === message.sentTime" (click)="onShowMessage(message)">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-8">
                        @if(!message.read){
                        <div class="dot"></div>
                        }
                        <h3>{{ message.sender }}</h3>
                    </div>
                    <span>{{message.sentTime | messageDate}}</span>
                </div>
                <h2>{{message.header}}</h2>
                <div class="subtitle d-flex justify-content-between align-items-end">
                    <p [innerHTML]="message.content | truncate:50"></p>
                </div>
            </li>
            }
        </ul>

    </aside>
    <div class="message-content py-3xl px-4xl">
        <rqa-message-content [message]="selectedMessage()"></rqa-message-content>
    </div>
    <rqa-message-create></rqa-message-create>
</div>